const countrySelect = () => {
  const selectFields = document.querySelectorAll('.wpcf7-countrytext');
  if (selectFields) {
    selectFields.forEach(field => {
      // eslint-disable-next-line no-param-reassign
      field.disable = true;
      // eslint-disable-next-line no-param-reassign
      field.setAttribute('readonly', true);
    });
  }
};

window.addEventListener('DOMContentLoaded', countrySelect);

const form = () => {
  const inputs = document.querySelectorAll('.c-popup .form-group');
  if (inputs) {
    Array.prototype.forEach.call(inputs, input => {
      const inputElement = input.querySelector(
        'input:not(.wpcf7-countrytext), textarea, .wpcf7-radio',
      );
      if (inputElement) {
        if (inputElement.classList.contains('wpcf7-radio')) {
          const radioElements = inputElement.querySelectorAll('label');
          if (radioElements) {
            Array.prototype.forEach.call(radioElements, radio => {
              radio.addEventListener('click', () => {
                const errorNotification = inputElement.nextElementSibling;
                if (
                  errorNotification &&
                  errorNotification.classList.contains('wpcf7-not-valid-tip')
                ) {
                  input.classList.remove('error');
                  errorNotification.classList.add('wpcf7-not-valid-tip--clear');
                }
              });
            });
          }
        } else {
          inputElement.addEventListener('focus', () => {
            input.classList.add('active');
          });
          inputElement.addEventListener('blur', () => {
            if (inputElement.value === '') {
              input.classList.remove('active');
            } else {
              const errorNotification = inputElement.nextElementSibling;
              if (
                errorNotification &&
                errorNotification.classList.contains('wpcf7-not-valid-tip')
              ) {
                input.classList.remove('error');
                errorNotification.classList.add('wpcf7-not-valid-tip--clear');
              }
            }
          });
        }
      }
    });
  }

  const formulars = document.querySelectorAll('.c-popup .wpcf7');
  if (formulars) {
    Array.prototype.forEach.call(formulars, formular => {
      formular.addEventListener(
        'wpcf7mailsent',
        // eslint-disable-next-line no-unused-vars
        event => {
          const formInputs = formular.querySelectorAll('.form-group');
          if (formInputs) {
            Array.prototype.forEach.call(formInputs, input => {
              const inputElement = input.querySelector(
                'input, textarea, .wpcf7-radio',
              );
              if (inputElement) {
                input.classList.remove('active');
                input.classList.remove('error');
              }
            });
          }
        },
        false,
      );

      formular.addEventListener(
        'wpcf7invalid',
        // eslint-disable-next-line no-unused-vars
        event => {
          setTimeout(() => {
            const formInputs = formular.querySelectorAll('.form-group');
            if (formInputs) {
              Array.prototype.forEach.call(formInputs, input => {
                const inputElement = input.querySelector(
                  'input, textarea, .wpcf7-radio',
                );
                if (inputElement) {
                  if (inputElement.classList.contains('wpcf7-not-valid')) {
                    input.classList.add('error');
                  }
                }
              });
            }
          }, 300);
        },
        false,
      );
    });
  }
  /*
  * example cf7 file code
  * <div class="form-group form-group--file">
  * <div class="form-control-label">Document Upload <span>Please upload the documents you want to share with us! 1 file, max size 10MB. Accepted file formats: PDF, ZIP.</span></div>
  * <label for="documents">[file documents limit:10000 filetypes:pdf|zip class:form-control]<span class="file-label">Upload file</span></label>
  * </div>
  */
  const fileInputs = document.querySelectorAll('.form-group--file');
  if (fileInputs) {
    Array.prototype.forEach.call(fileInputs, input => {
      const inputElement = input.querySelector('input');
      const label = input.querySelector('.file-label');
      const labelVal = label.innerHTML;

      inputElement.addEventListener('change', e => {
        let fileName = '';
        fileName = e.target.value.split('\\').pop();
        if (fileName) {
          label.innerHTML = fileName;
        } else {
          label.innerHTML = labelVal;
        }
      });
    });
  }
};

window.addEventListener('DOMContentLoaded', form);

/*
document.addEventListener('DOMContentLoaded', () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // Check for a specific parameter, e.g., 'myParam'
  if (urlParams.has('show_form')) {
    // eslint-disable-next-line no-shadow
    const form = urlParams.get('show_form');
    const formWrapper = document.getElementById(form);
    if (formWrapper) {
      const formButton = formWrapper.querySelector('[data-popup-trigger]');
      if (formButton) {
        formButton.click();
      }
    }
  }
});*/


// Function to handle showing the form
const handleFormDisplay = () => {
  // Check for hash parameter
  const hash = window.location.hash;
  if (hash.startsWith('#show_form=')) {
    const formId = hash.replace('#show_form=', '');
    const formWrapper = document.getElementById(formId);
    if (formWrapper) {
      // Scroll to the section
      formWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Find and click the form button
      const formButton = formWrapper.querySelector('[data-popup-trigger]');
      if (formButton) {
        // Small delay to allow scroll to complete
        setTimeout(() => {
          formButton.click();
        }, 300);
      }
    }
  }

  // Also check for query string parameter (original functionality)
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has('show_form')) {
    // eslint-disable-next-line no-shadow
    const form = urlParams.get('show_form');
    const formWrapper = document.getElementById(form);
    if (formWrapper) {
      const formButton = formWrapper.querySelector('[data-popup-trigger]');
      if (formButton) {
        formButton.click();
      }
    }
  }
};

// Run on initial page load
document.addEventListener('DOMContentLoaded', handleFormDisplay);

// Run when the URL hash changes
window.addEventListener('hashchange', handleFormDisplay);
